import React from 'react';

import TextPane from 'pages/components/TextPane';
import { formatJSON } from 'pages/utils/text';

import { logPropTypes } from './utils';

const AuditTrailDetailsMeta = props => {
  const { log } = props;

  const { metadata } = log;

  return (
    <div className="cr-flex cr-flex-1 cr-ph-3 cr-pv-2">
      <TextPane
        className="cr-bg-snow cr-border-gray-100 cr-border-width-1 cr-border-style-solid cr-radius-1"
        style={{ height: '10rem' }}
        code
        clipboard
      >
        {formatJSON({ text: metadata, indent: 2 })}
      </TextPane>
    </div>
  );
};

AuditTrailDetailsMeta.propTypes = {
  log: logPropTypes,
};

export default AuditTrailDetailsMeta;
